import { FC, useState } from 'react';
import { GameControlButton } from '@whitesharx/starfall-frontend-core';
import { Icon } from '@whitesharx/starfall-frontend-ui-kit';
import { buttonStyles, containerStyles } from './styles.css';

export type RewindType = 'start' | 'previous' | 'play' | 'pause' | 'next' | 'end';

export type RewindProps = {
  onRewind: (type: RewindType) => void;
};

const Rewind: FC<RewindProps> = ({ onRewind }) => {
  const [playing, setPlaying] = useState(false);

  return (
    <div className={containerStyles}>
      <GameControlButton
        icon={<Icon name="chevronPrevious" />}
        className={buttonStyles}
        onClick={() => onRewind('start')}
      />
      <GameControlButton
        icon={<Icon name="leftArrow" />}
        className={buttonStyles}
        onClick={() => onRewind('previous')}
      />
      <GameControlButton
        icon={<Icon name={playing ? 'pause' : 'play'} />}
        className={buttonStyles}
        onClick={() => {
          onRewind(playing ? 'pause' : 'play');
          setPlaying((prev) => !prev);
        }}
      />
      <GameControlButton icon={<Icon name="rightArrow" />} className={buttonStyles} onClick={() => onRewind('next')} />
      <GameControlButton icon={<Icon name="chevronNext" />} className={buttonStyles} onClick={() => onRewind('end')} />
    </div>
  );
};

export default Rewind;
